import React, { PropsWithChildren } from "react";

interface Props {
  color?: string;
}

const Badge = (props: PropsWithChildren<Props>) => {
  const primaryColor = "rgba(10,119,230,1)";
  const badgeStyle = {
    ["--color" as any]: props.color ?? primaryColor,
  };

  return (
    <div className="Badge" style={badgeStyle}>
      {props.children}
    </div>
  );
};

export default Badge;
